var _path, _path2, _path3, _path4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNa({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 344.276V97.103a8.829 8.829 0 0 1 8.828-8.828h379.586L0 344.276z",
    fill: "#41479b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M512 167.724v247.172a8.829 8.829 0 0 1-8.828 8.828H123.586l388.414-256z",
    fill: "#73af00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M512 172.702V97.103a8.829 8.829 0 0 0-8.828-8.828H383.139L0 339.298v75.598a8.829 8.829 0 0 0 8.828 8.828h120.033L512 172.702z",
    fill: "#f5f5f5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M512 141.047V97.103a8.829 8.829 0 0 0-8.828-8.828h-71.718L0 370.953v43.944a8.829 8.829 0 0 0 8.828 8.828h71.718L512 141.047z",
    fill: "#ff4b55"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffe15a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.207 145.894c8.691 0 16.557 3.521 22.254 9.214l3.125-21.686-17.235 13.561-8.145-20.362-8.145 20.362-17.235-13.561 3.125 21.686c5.699-5.694 13.565-9.214 22.256-9.214zM67.935 199.634c-5.693-5.697-9.214-13.565-9.214-22.254 0-8.691 3.521-16.557 9.214-22.254L46.249 152l13.561 17.235-20.362 8.145 20.362 8.145-13.561 17.235 21.686-3.126zM140.966 177.379l-20.362-8.145L134.165 152l-21.686 3.125c5.693 5.697 9.214 13.565 9.214 22.254 0 8.69-3.521 16.557-9.214 22.254l21.686 3.125-13.561-17.235 20.362-8.144zM90.207 208.865c-8.691 0-16.557-3.521-22.254-9.214l-3.125 21.686 17.235-13.561 8.145 20.362 8.145-20.362 17.235 13.561-3.125-21.686c-5.699 5.694-13.565 9.214-22.256 9.214z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.21,
    cy: 177.38,
    r: 25.709
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNa);
export default __webpack_public_path__ + "static/media/na.c576401ad19b97096c75ccebdb8300aa.svg";
export { ForwardRef as ReactComponent };